export default __webpack_public_path__ + "static/media/Group1288@2x.efd29b09.png";